<template>
  <div class="app-container">
    <el-card shadow="never">
      <div class="filter-container">
        <div class="searchContainer">
          <label class="inputLabel">广告主ID：</label>
          <el-input
            v-model="advertisersQuery.account_id"
            placeholder="请输入内容"
          />
        </div>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleSearch"
        >
          搜索
        </el-button>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-refresh"
          @click="handleSearchReset"
        >
          重置
        </el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        highlight-current-row
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        class="border-gray"
        fit
        style="width: 100%; justify-content: space-between;"
      >

        <el-table-column
          prop="id"
          label="id"
          align="center"
        />
        <!-- <el-table-column
          prop="account_name"
          label="广告主名称"
          align="center"
        /> -->

        <el-table-column
          prop="account_id"
          label="广告主id"
          align="center"
        />
        <el-table-column
          prop="page_id"
          label="落地页id"
          align="center"
        />
        <el-table-column
          prop="page_name"
          label="落地页名称"
          align="center"
        />
        <el-table-column
          prop="page_template_id"
          label="落地页模板 id"
          align="center"
        />
        <el-table-column
          label="组件素材内容"
          type="expand"
        >
          <template slot-scope="props">
            <el-form
              v-for="item in JSON.parse(props.row.page_elements_spec_list)"
              :key="item"
              label-position="left"
              inline
              class="demo-table-expand"
            >
              <el-form-item label="">
                <span>{{ item }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="page_elements_spec_list"
          label="组件素材内容"
          align="center"
        /> -->
        <!-- <el-table-column
          prop="preview_url"
          label="视频文件预览地址"
          align="center"
        >
          <template scope="scope">
            <video
              width="150"
              height="150"
              controls
              muted
              :src="scope.row.preview_url"
            />
          </template>
        </el-table-column> -->
        <el-table-column
          prop="preview_url"
          label="微信原生页的预览地址"
          align="center"
          width="300px"
        >

          <template slot-scope="scope">
            <el-tooltip
              :content="scope.row.preview_url"
              placement="top"
            >

              <span
                class="url-wrapper"
                @click="copy(scope.row)"
              >
                {{ scope.row.preview_url }}
              </span>
            </el-tooltip>
          </template>
          <!-- <template scope="scope">
            <el-image
              style="width: 90px; height: 90px"
              :src="scope.row.preview_url"
              fit="cover"
              :preview-src-list="[scope.row.preview_url]"
              @click.stop="handleClickStop"
            />
          </template> -->
        </el-table-column>
        <el-table-column
          prop="page_type"
          label="落地页类型"
          align="center"
        />
        <el-table-column
          prop="source_type"
          label="视频/图片/原生页等素材的创建来源类型"
          align="center"
        />
        <el-table-column
          prop="video_resource_status"
          label="微信原生页视频资源状态"
          align="center"
        />
        <el-table-column
          prop="canvas_type"
          label="视频帧数"
          align="center"
        />
        <el-table-column
          prop="video_bit_rate"
          label="原生页类型"
          align="center"
        />
        <el-table-column
          prop="owner_uid"
          label="原生页授权方 uid"
          align="center"
        />
        <el-table-column
          prop="audio_bit_rate"
          label="音频码率b/s"
          align="center"
        />
        <el-table-column
          prop="page_status"
          label="状态"
          align="center"
        />

        <el-table-column
          prop="updated_at"
          label="更新时间"
          align="center"
        />

      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>

  </div>
</template>

<script>
import { material_wechat_pages } from '@/api/customer.js'

import PaginationRight from '@/components/PaginationRight/index.vue'
// import detailsList from '../../customer/accountList/components/details.vue'
export default {
  name: 'AccountList',
  components: {
    PaginationRight
  },
  data() {
    return {
      tableData: [],
      search: {},
      total: null, // 数据总条数啊
      // table列表数据请求参数
      advertisersQuery: {
        account_id: null,
        page: 1, // 当前页码
        page_size: 10 // 广告在系统中的状态
      },
      // 枚举值请求参数
      enumerationsQuery: {
        account_id: null,
        api_name: 'account_management/advertisers'
      },
      accountIdsQuery: [], // 获取用户余额的参数
      loading: false // 加载动画
    }
  },
  created() {
    this.getAdvertiserList()
  },
  methods: {
    handleClickStop() {
      this.$nextTick(() => {
        const domImageView = document.querySelector('.el-image-viewer__mask') // 获取遮罩层dom
        if (!domImageView) {
          return
        }
        domImageView.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },

    getAdvertiserList() {
      this.loading = true
      material_wechat_pages(this.advertisersQuery).then(res => {
        console.log('res:', res)
        this.tableData = res.data.list
        this.total = res.data.total
        this.loading = false
        console.log(22)
      })
    },
    // 关闭iframe
    closeDialog() {
      this.dialogVisible = false
      this.authorizeURLData = null
    },
    // 抓取分页数据
    fetchPageSize(data) {
      this.advertisersQuery.page_size = data
      this.getAdvertiserList()
    },
    // 抓取当前页数据
    fetchCurrentPage(data) {
      this.advertisersQuery.page = data
      this.getAdvertiserList()
    },
    copy(data) {
      const newdata = data.preview_url
      if (navigator.clipboard) {
        console.log(1)
        navigator.clipboard.writeText(newdata)
      } else {
        const dummyInput = document.createElement('textarea')
        dummyInput.value = newdata
        dummyInput.style.left = '-9999px'
        dummyInput.style.top = '-9999px'
        dummyInput.style.textAlign = 'left'
        dummyInput.style.whiteSpace = 'pre-line'
        document.body.appendChild(dummyInput)
        dummyInput.select()
        document.execCommand('copy')
        document.body.removeChild(dummyInput)
      }
      this.$message.success('复制成功')
    },

    // 搜索
    handleSearch() {
      this.advertisersQuery.page = 1
      this.advertisersQuery.page_size = 10
      this.getAdvertiserList()
    },
    // 重置搜索框
    handleSearchReset() {
      this.advertisersQuery = {
        account_id: null,
        status: null,
        page: 1, // 当前页码
        page_size: 10 // 广告在系统中的状态
      }
      this.getAdvertiserList()
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .block {
  justify-content: left;
}
.searchContainer {
  display: flex;
  font-size: 14px;
  float: left;
  margin-right: 30px;
  label {
    padding-top: 10px;
    vertical-align: middle;
    font-weight: normal;
  }
  .inputLabel {
    // display: inline-block;
    width: 120px;
  }
}

.overflow {
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.url-wrapper {
  color: blue;
  display: inline-block;
  width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
